module.exports = __webpack_public_path__ + "img/Stage_7_Atmo.4e29d310.jpg";